interface BrowserStorage {
    getItem(key: string): any;
    setItem(key: string, data: any): void;
    removeItem(key: string): void;
    clear(): void;
}

// Create a wrapper for session, local storage
class Storage implements BrowserStorage {
    // Storage: localStorage or sessionStorage
    storage: BrowserStorage;

    // Backup memory data
    state: { [key: string]: any } = {};

    // Costruct with the storage
    constructor(storage: BrowserStorage) {
        this.storage = storage;
    }

    // Get the data either from storage
    getItem(key: string): any {
        // Return the data if present
        if (this.state[key]) {
            return this.state[key];
        }

        // Fallback to session
        try {
            this.state[key] = JSON.parse(this.storage.getItem(key));
        } catch (e) {}

        // Return
        return this.state[key];
    }

    // Set the data in storage
    setItem(key: string, data: any): void {
        // Set it in memory too
        this.state[key] = data;

        // Save it in session storage if possible
        try {
            this.storage.setItem(key, JSON.stringify(data));
        } catch (e) {}
    }

    // Remove the item from storage
    removeItem(key: string): void {
        // Unset it from memory too
        delete this.state[key];

        // Remove the item from session
        try {
            this.storage.removeItem(key);
        } catch (e) {}
    }

    // Clear the storage
    clear(): void {
        // Clear the memory
        this.state = {};

        // Remove the clear
        try {
            this.storage.clear();
        } catch (e) {}
    }
}

const isLocalStorageAvailable = () => {
    try {
      if (typeof localStorage === 'object' && navigator.cookieEnabled)
      {
        return true;
      }
      return false;
    } catch (e) {
        return false;
    }
}

const isSessionStorageAvailable = () => {
    try {
      if (typeof sessionStorage === 'object' && navigator.cookieEnabled)
      {
          return true;
      }
      return false;
    } catch (e) {
        return false;
    }
}

// Export the local and session storage
export const localStorage = isLocalStorageAvailable() ? new Storage(window.localStorage) : null;
export const sessionStorage =  isSessionStorageAvailable() ? new Storage(window.sessionStorage) : null;
